<template>
  <div class="student-list">
    <div class="student-search" v-if="search">
      <input type="text" :placeholder="app.strings.common.search" v-model="query" />
      <font-awesome-icon class="icon" :icon="['fas', 'search']" />
    </div>
    <div class="student-list">
      <div class="student-row" v-for="student in studentsFiltered" v-bind:key="student.code" v-on:click="$emit('onSelect', student)">
        <img src="@/assets/images/avatar.svg" />
        <div>
          {{ student.first_name }} {{ student.last_name_1 }} {{ student.last_name_2 }}
          <small v-if="student.code && student.code !== 'all'">{{ student.code }}</small>
        </div>
      </div>
      <div class="student-empty" v-if="search && query.trim().length > 0 && studentsFiltered.length === 0">{{ app.strings.common.no_results }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'student-list',
  data () {
    return {
      query: ''
    }
  },
  computed: {
    studentsFiltered () {
      let students = this.students

      if (this.query.trim().length > 0) {
        students = students.filter((student) => {
          if (student.code === 'all') {
            return false
          }
          let name = student.first_name.toLowerCase() + ' ' + student.last_name_1.toLowerCase() + ' ' + student.last_name_2.toLowerCase()
          return name.indexOf(this.query.toLowerCase()) != -1 || student.code.toLowerCase().indexOf(this.query.toLowerCase()) != -1
        })
      }

      // By name, as it reads; «all», the option for every student, stays first.
      let fullName = (student) => [student.first_name, student.last_name_1, student.last_name_2].join(' ')
      students = [...students].sort((a, b) => {
        if (a.code === 'all' || b.code === 'all') {
          return a.code === 'all' ? -1 : 1
        }
        return fullName(a).localeCompare(fullName(b), 'es', {sensitivity: 'base'})
      })

      this.$emit('onSearch', students)

      return students
    }
  },
  props: {
    'app': {
      type: Object,
      default: () => {
        return {}
      }
    },
    'students': {
      type: Array,
      default: () => {
        return []
      }
    },
    'search': {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  mounted () {

  },
  methods: {

  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
// Valkiria look: this component is only used in the app screens.

.student-empty {
  padding: 24px 12px;
  color: #64748b;
  font-size: 14px;
  text-align: center;
}

// Always in sight over a long list, 8px under the top bar: the screens scroll
// from 20px below the top of the window, and from the top itself on desktop.
.student-search {
  position: sticky;
  top: 48px;
  z-index: 10;
  margin-bottom: 4px;
}

.student-search::before {
  content: '';
  position: absolute;
  top: -8px;
  right: -2px;
  bottom: -4px;
  left: -2px;
  z-index: -1;
  background-color: #f3f6fa;
}

.student-search > input {
  width: 100%;
  height: 48px;
  background-color: #FFFFFF;
  border: 1px solid #e8edf3;
  border-radius: 14px;
  color: #1f2a37;
  font-size: 16px;
  box-sizing: border-box;
}

.student-search > input::placeholder {
  color: #64748b;
  font-size: 16px;
}

.student-search > .icon {
  position: absolute;
  top: 16px;
  left: 16px;
  color: #64748b;
}

.student-row {
  display: flex;
  width: 100%;
  min-height: 60px;
  align-items: center;
  padding: 10px 14px;
  box-sizing: border-box;
  background-color: #FFFFFF;
  border: 1px solid #e8edf3;
  margin: 10px 0;
  border-radius: 16px;
  box-shadow: 0 12px 30px rgba(20, 67, 107, 0.08);
  cursor: pointer;
}

.student-row > img {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  border: 2px solid rgba(32, 113, 183, 0.25);
}

.student-row > div {
  flex: 1;
  min-width: 0;
  padding: 0 0 0 12px;
  color: #1f2a37;
  font-family: 'Lexend', sans-serif;
  font-size: 15px;
  font-weight: 500;
  overflow-wrap: anywhere;
}

.student-row > div > small {
  display: block;
  color: #64748b;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  font-weight: 400;
}

@media (min-width: 1024px) {
  .student-search {
    top: 68px;
  }
}

// Tablet: two columns; on desktop the app's stylesheet makes them three.
@media (min-width: 768px) and (max-width: 1023px) {
  .student-list > .student-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 10px;
    align-items: stretch;
  }

  .student-list > .student-list > .student-row {
    margin: 5px 0;
  }

  .student-empty {
    grid-column: 1 / -1;
  }
}
</style>
